module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "title": "Contents"
    }
  }, [_c('p', {
    staticClass: "toc_h"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_vii",
      "title": "vii"
    }
  }, [_c('b', [_vm._v("CONTENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_hd",
    attrs: {
      "id": "rsec1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Frontmatter2#sec1"
    }
  }, [_c('i', [_vm._v("Note on Transliteration")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_hd",
    attrs: {
      "id": "rsec2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Acknowledgments#sec2"
    }
  }, [_c('i', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ht",
    attrs: {
      "id": "rsec3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Introduction#sec3"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_c",
    attrs: {
      "id": "rsec4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter_1#sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "space"
  }, [_vm._v("Men of Letters")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_c",
    attrs: {
      "id": "rsec5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter_2#sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "space"
  }, [_vm._v("How the Word Became Flesh")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_c",
    attrs: {
      "id": "rsec6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter_3#sec6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "space"
  }, [_vm._v("Texts on Trial")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_c",
    attrs: {
      "id": "rsec7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter_4#sec7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4."), _c('span', {
    staticClass: "space"
  }, [_vm._v("Literary Apostasy")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_c",
    attrs: {
      "id": "rsec8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter_5#sec8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5."), _c('span', {
    staticClass: "space"
  }, [_vm._v("Readers’ Paradise")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_c ",
    attrs: {
      "id": "rsec9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter_6#sec9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6."), _c('span', {
    staticClass: "space"
  }, [_vm._v("The Talmudic Passion")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rsec10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Epilogue#sec10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue: Reflections on the Value of Literature")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ht",
    attrs: {
      "id": "rsec11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Bibliography#sec11",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_hd",
    attrs: {
      "id": "rsec12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Index#sec12",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Index")])]), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_viii",
      "title": "viii"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48b6a414","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Contents.vue
// module id = 72
// module chunks = 0